export const isNotNullOrEmpty = (str?: string) => str !== undefined && str !== null && str !== '';
